import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: ${(props) => props.theme.colors.selected};
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.selected};
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.disabled};

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: ${props.theme.colors.error};
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: ${props.theme.colors.highlight};
      color: ${props.theme.colors.highlight};
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: ${props.theme.colors.highlight};
    `}

  input {
    background: transparent;
    flex: 1;
    border: 0;
    color: ${(props) => props.theme.colors.feature};

    &::placeholder {
      color: ${(props) => props.theme.colors.disabled};
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled.div`
  height: 20px;
  margin-left: 16px;

  div {
    svg {
      margin: 0;
    }
  }
`;
